import { EntityStatus } from '../../../../Entity'
import { APPLICANT_STAGES } from '../../../../RentalPortalApplicant'

function RentalPortalApplicantsStageFilterListItemContent({ value }) {
  return <EntityStatus id={value?.value} statuses={APPLICANT_STAGES} />
}

export default RentalPortalApplicantsStageFilterListItemContent
